import { Component, Host, h, Prop, Element } from '@stencil/core';
import { ColorHelper } from '../../utils/color-helpers';

@Component({
  tag: 'sy-orbital-loading',
  styleUrls: ['scss/index.scss', 'scss/_tokens.scss'],
  shadow: true,
})
export class OrbitalLoading {
  @Element() el: HTMLSyOrbitalLoadingElement;

  /**
   * Defines loading size.
   */
  @Prop({ reflect: true }) size: 'small' | 'medium' | 'large' = 'small';

  private getCSSTokens() {
    const firstColor = getComputedStyle(this.el).getPropertyValue('--sy-loading-color');

    if (!firstColor) {
      return {};
    }

    const secondColor = ColorHelper.getTintOrShadeColor(firstColor || 'black');

    return {
      '--sy-orbital-loading-color-small-circle': firstColor,
      '--sy-orbital-loading-color-medium-circle': secondColor,
      '--sy-orbital-loading-color-large-circle': firstColor,
    };
  }

  /**
   * O valor do raio é composto por 3 valores. O primeiro representa 100%, o segundo representa que apenas 90% do container será ocupado
   * e o ultimo representa a proporção de cada circulo em relação ao maior.
   */

  render() {
    return (
      <Host style={this.getCSSTokens()}>
        {this.size !== 'medium' && (
          <svg class="loading-small-svg">
            <circle class="loading-small-circle" cx="50%" cy="50%" r={`${100 * 0.45 * 0.5}%`} />
          </svg>
        )}
        {this.size !== 'small' && (
          <svg class="loading-medium-svg">
            <circle class="loading-medium-circle" cx="50%" cy="50%" r={`${100 * 0.45 * 0.75}%`} />
          </svg>
        )}
        <svg class="loading-large-svg">
          <circle class="loading-large-circle" cx="50%" cy="50%" r={`${100 * 0.45}%`} />
        </svg>
      </Host>
    );
  }
}
